import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({

    st0: {
        fill: 'url(#SVGID_1_)',
    },

    st1: {
        fill: '#1E0945',
    },

    st2: {
        fill: '#FFFFFF',
    },

    st3: {
        fontFamily: 'Roboto, sans-serif',
        // fontFamily: 'Open Sans, sans-serif',
    },

    st4: {
        fontSize: '15px',
        // fontWeight: '600',
    },

}));
